import * as React from "react";
const SvgEditorTextRemove = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { stroke: "red", strokeWidth: 2, d: "M21 3L3 21", fillRule: "evenodd" }));
export default SvgEditorTextRemove;
